module.exports = __webpack_public_path__ + "media/images/icon__point--gained-14fe72d32252563cb24c0a64c4fcb6a2.png";